<template>
  <div class="collection-record-add">
    <QS-scroller-box>
      <QS-h3-title :title="pageTile" has-bottom-line />
      <QS-h4-title title="应收信息" />
      <collection-record-add-form
        ref="collectionRecordAddForm"
        :addFormData="addFormData"
        :customerName="customerName"
        :isCustomer="isCustomer"
        :customerList="customerList"
        :paymentTypeList="paymentTypeList"
        @businessLicenceSuccess="businessLicenceSuccess"
        @uploading="uploading"
        @uploaded="uploaded"
      />
      <QS-h4-title title="应收款项" />
      <collection-record-add-table
        ref="collectionRecordAddTable"
        :customerId="addFormData.customerId"
        :tableDataFrom="tableDataFrom"
        :collectionSelect="collectionSelect"
        :freeTypeList="formatEnumeration(freeTypeList)"
        @amountChange="amountChange"
        @handleDel="handleDel"
      ></collection-record-add-table>
      <collection-record-add-amount
        :remainAmountTotal="remainAmountTotal"
        :amountTotal="amountTotal"
        :continueAmountTotal="continueAmountTotal"
      />
      <collection-record-add-bottom
        slot="bottomAction"
        :type="type"
        :oLoading="oLoading"
        @cancel="cancel"
        @addResult="addResult"
        @dingTalk="addResult"
        :dingTalkShow="dingTalkShow"
      />

      <!-- 钉钉审批异常弹窗 -->
      <approve-validate-dialog
        ref="approveValidateDialogRef"
        :dingTalkShow="dingTalkShow"
        :sunbmitFun="sunbmitData"
        :tableData="tableDataFrom.tableData"
        @reloadClick="getDingTalkBtnShow"
      />
    </QS-scroller-box>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// eslint-disable-next-line import/no-cycle
import { getCollectionRecordList } from '@/api/financeApi'

import { getAccountDetail } from '@/api/financeApi/accruedChange'
import { addRecordReceivableSignCheck } from '@/api/currencyApi'
import CollectionRecordAddTable from './components/CollectionRecordAddTable.vue'
import CollectionRecordAddForm from './components/CollectionRecordAddForm.vue'
import CollectionRecordAddAmount from '../components/CollectionRecordAdd/CollectionRecordAddAmount.vue'
import CollectionRecordAddBottom from '../components/CollectionRecordAdd/CollectionRecordAddBottom.vue'
import ApproveValidateDialog from '../components/ApproveValidateDialog/index.vue'
import * as globalApi from '@/api/global'
import { FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'

const titleMap = {
  order: '新增订单收款',
  singleReceivable: '新增收款',
  overdue: '新增逾期收款',
  remind: '新增催租收款',
}

export default {
  name: 'CollectionRecordAdd',
  components: {
    CollectionRecordAddTable,
    CollectionRecordAddForm,
    CollectionRecordAddAmount,
    CollectionRecordAddBottom,
    ApproveValidateDialog,
  },
  data() {
    return {
      previewId: '', // 预览ID
      customerList: [],
      collectionSelect: [],
      isCustomer: false,
      type: '', // order 订单入口、singleReceivable 线下收款入口
      pageTile: '',
      customerName: '', // 付款方
      addFormData: {
        paymentType: '', // 付款类型
        attachment: [], // 收款凭证
        customerType: '',
        customerId: '',
        receivableAccountId: '',
        paymentAccount: '',
        accountNo: '',
        bankName: '',
        completeTime: '',
        remarks: '',
      },

      tableDataFrom: {
        tableData: [],
      },
      oLoading: {
        uploading: false,
        submitting: false,
      },
      dingTalkShow: false,
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
      paymentTypeList: (state) => state.global.paymentTypeList, // 付款类型
    }),
    // 剩余应收金额
    remainAmountTotal() {
      let remainAmountTotal = 0
      const { tableData } = this.tableDataFrom
      tableData.length > 0 &&
        tableData.forEach((item) => {
          remainAmountTotal += Number(item.remainAmount)
        })
      return remainAmountTotal
    },
    // 本次应收金额
    amountTotal() {
      let amountTotal = 0
      const { tableData } = this.tableDataFrom
      tableData.length > 0 &&
        tableData.forEach((item) => {
          amountTotal += Number(item.amount) * 100
        })
      return (amountTotal / 100).toFixed(2)
    },
    // 仍需收取金额
    continueAmountTotal() {
      return this.remainAmountTotal - this.amountTotal
    },
  },
  methods: {
    // 通过应收ID匹配关联单id，查找出租金对应的滞纳金 - 索引
    getOverdueItemIndex(id) {
      return this.tableDataFrom.tableData.findIndex(
        (item) => item.relReceivableId === id,
      )
    },
    // 附件上传中
    uploading() {
      this.oLoading.uploading = true
    },
    // 附件上传成功或者失败
    uploaded() {
      this.oLoading.uploading = false
    },
    // 获取应收款项列表
    getCollectionRecordList(ids) {
      getCollectionRecordList({ ids })
        .then((res) => {
          const { code, data = [] } = res
          if (code === 1) {
            this.tableDataFrom.tableData =
              (data.length > 0 &&
                data.map((item, index) => {
                  return {
                    ...item,
                    amount: item.remainAmount || '',
                    categoryCode: item.categoryCode || '',
                    serialNum: index + 1,
                  }
                })) ||
              []
            const { customer, customerId, customerType } = data[0] || {}
            this.customerName = customer
            this.addFormData.customerId = customerId
            if (customerId) {
              this.getPayerChange(customerId)
            } // 临时判断逻辑
            this.addFormData.customerType = customerType
          }
        })
        .catch((error) => {
          console.log(error, 'getCollectionRecordList')
        })
    },
    // 删除应收款项
    handleDel(i) {
      let delItem = this.tableDataFrom.tableData.splice(i, 1)
      delItem = delItem[0]
      const { id, content } = delItem
      // 如果是租金
      if (content === FEE_CODE_MAP.ZU_JIN) {
        const overdueItemIndex = this.getOverdueItemIndex(id)
        // 如果有对应的滞纳金则删除滞纳金
        if (overdueItemIndex > -1) {
          this.tableDataFrom.tableData.splice(overdueItemIndex, 1)
        }
      }
      this.tableDataFrom.tableData.forEach((item, index) => {
        item.serialNum = index + 1
      })
    },
    // 监听本次应收金额变化
    amountChange(value, index) {
      this.$set(this.tableDataFrom.tableData[index], 'amount', value)
    },
    // 付款方选中事件
    async getPayerChange(customerId) {
      if (customerId) {
        try {
          const { code, data } = await getAccountDetail({
            customerId,
            customerType: 2,
          })
          if (code === 1) {
            // accountNo：开户账号，accountName：账户名称，bankName：开户银行名称
            // 付款账户
            this.addFormData.paymentAccount = data?.accountName || ''
            //  开户账号
            this.addFormData.accountNo = data?.accountNo || ''
            // 开户银行名称
            this.addFormData.bankName = data?.bankName || ''
          }
        } catch (error) {
          console.log(error, 'getPayerChange')
        }
      }
    },
    cancel(status = false) {
      this.$refreshBack(status) // 关闭当前tab
    },
    businessLicenceSuccess(url) {
      this.addFormData.attachment.push(url)
    },
    // 设置提交参数
    setSunbmitParams() {
      const {
        type,
        tableDataFrom: { tableData },
        amountTotal,
        addFormData,
      } = this
      const isValideTableData = tableData && tableData.length > 0
      const receivableOrderInfos = []
      isValideTableData &&
        tableData.forEach((item) => {
          receivableOrderInfos.push({
            ...item,
            receivableId: item.id,
          })
        })

      const tempOrderData = {
        sourceOrderId: isValideTableData && tableData[0]?.sourceOrderId ? tableData[0]?.sourceOrderId : '',
        sourceOrderType:
          (isValideTableData && tableData[0].sourceOrderType) || '',
      }

      const tempOverdueData = {
        sourceOrderId: this.$route.query.overdueId,
        sourceOrderType: 7, // 7: 逾期收款
      }

      const params = {
        ...addFormData,
        receivableOrderInfos,
        totalAmount: amountTotal,
        attachment: this.getUoloadCommonFileData(addFormData.attachment),
        previewId: this.previewId,
        approvalAccessModeType: this.dingTalkShow ? 2 : 1,
        receivableSourceType: Number(this.$route.query.approvalOrigin), // 审批来源
      }
      // 新增订单收款 或 新增逾期收款
      if (type === 'order') {
        Object.assign(params, tempOrderData)
      } else if (type === 'overdue') {
        Object.assign(params, tempOverdueData)
      }
      return params
    },
    // 提交审批
    addResult() {
      this.$refs.collectionRecordAddTable.handleValidate().then(() => {
        this.$refs.collectionRecordAddForm.$refs.addFormData.validate(
          async (valid) => {
            if (!valid) return
            // 钉钉审批
            await this.getDingTalkBtnShow()
            // 后台审批 提交
            if (!this.dingTalkShow) {
              this.$refs.approveValidateDialogRef.receivableFilterReceivable()
              return
            }
            this.$refs.approveValidateDialogRef.sunbmitDdApprove()
          },
        )
      })
    },
    async sunbmitData(filterReceivableIdList = []) {
      if (this.oLoading.submitting) return
      this.oLoading.submitting = true
      try {
        const submitData = {
          ...this.setSunbmitParams(),
          filterReceivableIdList,
        }
        const { code, data } = await addRecordReceivableSignCheck(submitData)
        if (code === 1 && data) {
          this.$EventBus.$emit('batchOfflineCollectSuccess')
          const msg = this.dingTalkShow ? '发起审批成功' : '提交成功！'
          this.$message.success(msg)
          this.cancel(true)
        }
      } catch (error) {
        console.log(error, 'addResult')
      } finally {
        this.oLoading.submitting = false
      }
    },
    // 获取钉钉审批按钮开启
    getDingTalkBtnShow() {
      globalApi
        .getSubmitDingTalkShow({
          bizType: 1,
        })
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.dingTalkShow = data
          }
        })
    },
  },
  created() {
    const { paymentIds, type } = this.$route.query
    this.type = type
    // this.pageTile = type === 'order' ? '新增订单收款' : '新增收款'
    this.pageTile = titleMap[type]
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    // 获取付款方式
    this.$store.dispatch('getPaymentMethods', { type: 'paymentType' })
    // 获取应收列表
    paymentIds && this.getCollectionRecordList(String(paymentIds).split(','))
    this.getDingTalkBtnShow()
  },
}
</script>
